module.exports = __webpack_public_path__ + "img/SurveyClient.80783cce.png";